module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-2e5bc8d1551fe5258eb00966d2570eaa.png";